import { render, staticRenderFns } from "./SharedLinkPasswordDialogBox.vue?vue&type=template&id=705c1a7a&scoped=true&"
import script from "./SharedLinkPasswordDialogBox.vue?vue&type=script&lang=js&"
export * from "./SharedLinkPasswordDialogBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705c1a7a",
  null
  
)

export default component.exports